<template>
  <div>
    <div v-for="(action, i) in actions" :key="i" :class="{ disabled: action.disabled }">
      <Btn @click="execute(action)" :variant="action.variant" :loading="action.loading">{{
        action.name
      }}</Btn>
    </div>
  </div>
</template>

<script>
import Btn from "@/components/display/Btn";
import NavLink from "@/classes/NavLink";

export default {
  name: "ActionButtons",
  props: {
    actions: {
      type: Array,
      validator: (actions) => {
        let valid = true;
        actions.forEach((action) => {
          if (!(action instanceof NavLink)) valid = false;
        });
        return valid;
      },
    },
  },
  components: {
    Btn,
  },
  setup() {
    const execute = (action) => action.action();

    return {
      execute,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.action-icon {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    > * {
      pointer-events: none;
    }
  }
  &:not(:first-child) {
    margin-left: 1rem;
  }
}
</style>
